import React from "react";
import PropTypes from "prop-types";
import Header from "header/components/title";

const HeaderTitle = () => <Header title="Boring Legal Stuff" />;

export default HeaderTitle;
